module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAT5JREFUSEu11EFOwkAUgOH3irpkb9wZiDPlBHoBuAckkkCNegHrmoSFxUQM3AMuoBeAzhhcuHVLYkKC9Jlg0rQy7RtJ2u3MfH2T/ilCQQ8W5II17L4NhhTRl5Lerc0wVrDUwQgAm78gjZXwWhzOwkIFdUScJCEiamjpTfNwFnb1YEIA9SSCANNQdBt7w1I/NgFoZAawpURnnIVnTlxZPJQPI+cFCGrGwwjztRNdvFevlqb1TFiowEfEu7zrEtG9lp5vDdcWT260+X4FgDLz9ZdO6eB8Xm2Hf/cZJ07nxYVlzm8HNuXF0ob8dmBTXhxsyi8F5+fF8qn8YpjNi3XT+cWwTV6cncxvC/8jL86O89vCUgV9QLzhTtmsI8JzeNa9LBj+GB7Tat1DgBObqbL3kC4dbfzZ6fUn+9vc90WFwT/yhocXgkhd5gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/jiao.png
// module id = /YS7
// module chunks = 46